module.exports = __webpack_public_path__ + "img/color-g-2.dec697c.webp";